import {Component, Input, OnInit, SimpleChange, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-shipment-status-widget',
    templateUrl: './shipment-status-widget.component.html',
    styleUrls: ['./shipment-status-widget.component.scss']
})
export class ShipmentStatusWidgetComponent implements OnInit {

    @Input() public color: any;
    @Input() public variant: boolean;
    @Input() public label: string;
    @Input() public status: string;
    @Input() public showLabel: boolean;
    @Input() public asBadge: boolean;
    @Input() public shouldBeInline: boolean;
    @Input() public active: boolean = true;

    public colorClass;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {

        let color;
        if (this.color) {
            color = this.color;
        } else {
            color = this.statusColor(this.status, this.showLabel);
        }

        if (this.variant) {
            color['status-box__alternate'] = true;
        }

        if (!this.active) {
            color = 'status-box--dark';
        }

        this.colorClass = color;
    }

    /**
     * Common color definition for events status
     *
     * @param status
     * @param showLabel
     */
    statusColor(status: string, showLabel?: boolean): any {

        let color;
        switch (status) {
            case 'new':
                color = 'status-box--blue';
                break;

            case 'ready_to_ship':
                color = 'status-box--extra1';
                break;

            case 'complete':
            case 'handed_out':
                color = 'status-box--green';
                break;

            case 'deleted':
                color = 'status-box--extra2';
                break;

            case 'ready_to_pickup':
            case 'placed_in_boxen':
                color = 'status-box--lightgreen';
                break;

            case 'packing_completed':
                color = 'status-box--orange';
                break;

            case 'damaged':
                color = 'status-box--red';
                break;

            case 'packing_started':
                color = 'status-box--yellow';
                break;

            case 'ordered_remote':
                color = 'status-box--dark';
                break;

            case 'packed_remote':
                color = 'status-box--gray';
                break;

            case  'shipped_remote':
            case  'pending_remote':
                color = 'status-box--purple';
                break;

            case 'ordered_supplier':
                color = 'status-box--lightgray';
                break;

            case 'partial_complete':
            case 'partial_delivery':
                color = 'status-box--alternate-orange';
                break;

            case 'out_of_stock':
            case 'not_in_stock':
                color = 'status-box--pink';
                break;
            case 'invoiced':
                color = 'status-box--extra3';
                break;
        }

        const rt = {
            'status-box--large': showLabel,
        }
        rt[color] = true;

        return rt;
    }

    // @todo lav off funktion, farvet border, grå inside
}
